<div class="main-container-mid-side">
  <!-- E-Mail Verifiation -->
  <div class="verification-container flex-row for-inside-elements" *ngIf="this._DataHelper.selectedWallet.BranchType == 1 && !this._UserHelper.emailIsVerified">
    <div class="icon">
      <image-loader-utils url="info-circle" extraClasses="verification-info-icon"></image-loader-utils>
    </div>
    <div class="text">
      {{ 'email_verification_text' | translate }}
    </div>
    <div class="resent-mail-button" [ngClass]="{ disable: !this.resendMailButtonState }" (click)="openReSend()">
      {{ 'email_verification_text2' | translate }}
    </div>
  </div>

  <!--  0 => Not Checked-->
  <!--  1 => Pre Checked-->
  <!--  2 => Checked-->

  <!-- Insic Not Checked -->
  <div
    class="verification-container flex-row for-inside-elements"
    *ngIf="this._DataHelper.selectedWallet.BranchType == 1 && (_UiHelper.insicStatus == 0 || _UiHelper.insicStatus == -1 || _UiHelper.insicStatus == -2)"
    [routerLink]="getRouterLink()">
    <div class="icon">
      <image-loader-utils url="info-circle" extraClasses="verification-info-icon"></image-loader-utils>
    </div>
    <div class="text" *ngIf="_UiHelper.insicStatus == 0 || _UiHelper.insicStatus == -1">
      {{ 'insic_status_not_checked' | translate }}
      {{ 'insic_status_not_checked_link1_' | translate }}
    </div>
    <div class="text" *ngIf="_UiHelper.insicStatus == -2">
      {{ 'insic_status_not_checked' | translate }}
      {{ 'insic_status_not_checked_link' | translate }}
    </div>
    <div class="resent-mail-button" [ngClass]="{ disable: !this.resendMailButtonState }">{{ 'insic_status_not_checked_link_2' | translate }}</div>
  </div>
  <!-- Insic Not Checked -->

  <!-- Insic Pre Checked -->
  <div
    class="verification-container flex-row for-inside-elements"
    *ngIf="this._DataHelper.selectedWallet.BranchType == 1 && _UiHelper.insicStatus == 1"
    [routerLink]="['/account/bet-slip']">
    <div class="icon">
      <image-loader-utils url="info-circle" extraClasses="verification-info-icon"></image-loader-utils>
    </div>

    <div class="text">
      {{ 'insic_status_pre_checked' | translate }}
    </div>

    <div class="resent-mail-button" [ngClass]="{ disable: !this.resendMailButtonState }">
      {{ 'insic_status_pre_checked_link' | translate }}
    </div>
  </div>
  <!-- Insic Pre Checked -->

  <div *ngIf="'isMostPlayedTicket' | getEnv" class="mobile-display-none">
    <most-played-ticket-component></most-played-ticket-component>
  </div>
  <ng-container *ngIf="isMobileView === false">
    <div *ngIf="'getTopBets' | getEnv" #storySliderRow class="story-slider-row in-sports-component">
      <div *ngIf="this.seeMore && whichPart !== 'first'" class="go-left" (click)="goLeft()">
        <image-loader-utils url="up-arrow" extraClasses="slidermenusvg"></image-loader-utils>
      </div>

      <div #storySliderBox class="story-slider-box" [ngClass]="{ seeMore: seeMore === true, wideSpace: whichPart !== 'first' && whichPart !== 'last' }">
        <div class="story-slider-item" [routerLink]="['/favorites']" *ngIf="this._UserHelper.isSignedIn && this._DataHelper.favList.length > 0">
          <div class="story-slider-icon-count">
            <image-loader-utils url="star" extraClasses="story-slider-icon favorited"></image-loader-utils>
            <div class="story-slider-count">
              {{ this._DataHelper.favList.length }}
            </div>
          </div>
          <div class="story-slider-sport-name">{{ 'Favorites' | translate }}</div>
        </div>
        <div
          *ngIf="('isMySlipLive' | getEnv) && this._DataHelper?.mySlipMatchList?.length > 0"
          class="story-slider-item"
          [ngClass]="{ selected: this._DataHelper.isMySlipButton }"
          (click)="this.mySlipButtonAction()">
          <div class="story-slider-icon-count">
            <image-loader-utils url="in-play" extraClasses="story-slider-icon slidermenusvg"></image-loader-utils>
            <div class="story-slider-count">
              {{ this._DataHelper?.mySlipMatchList?.length }}
            </div>
          </div>
          <div class="story-slider-sport-name">
            {{ 'my_slip_text' | translate }}
          </div>
        </div>

        <div class="story-slider-item" [ngClass]="{ selected: selectedSportId === -2 }" (click)="onClickAllEvent(-2)">
          <div class="story-slider-icon-count">
            <image-loader-utils url="highlights" extraClasses="story-slider-icon slidermenusvg"></image-loader-utils>
          </div>
          <div class="story-slider-sport-name">
            {{ 'Highlights' | translate }}
          </div>
        </div>
        <div
          class="story-slider-item"
          *ngFor="let item of mainData; let i = index"
          [ngClass]="{ selected: item.SportId == selectedSportId }"
          (click)="onClickAllEvent(item.SportId)">
          <div class="story-slider-icon-count">
            <image-loader-utils [url]="this.sportsSvgList[item.SportId]?.svgKey" extraClasses="slidermenusvg"></image-loader-utils>
          </div>
          <div class="story-slider-sport-name">{{ item.SportName }}</div>
        </div>
      </div>
      <div *ngIf="seeMore && whichPart !== 'last'" class="go-right" (click)="goRight()">
        <image-loader-utils url="up-arrow" extraClasses="slidermenusvg"></image-loader-utils>
      </div>
    </div>

    <div class="banner-container">
      <a href="https://tbet24.com/casino/lobby/0/0" target="_blank" rel="noopener noreferrer">
        <img src="https://cdnsport.s3.eu-central-1.amazonaws.com/tc24/cms/casino-banner-web.png" alt="Banner" class="banner-image" />
      </a>
    </div>
  </ng-container>
  <div class="container">
    <div class="content">
      <div class="sports-container">
        <div class="odd-header mobile">
          <div class="odd-box-row">
            <div class="odd-box" *ngFor="let odd of oddComboList" [ngClass]="{ active: combo1SelectedOdd.OddId == odd.OddId }" (click)="oddBoxClick(odd, 0)">
              {{ odd.OddName | translate }}
            </div>
          </div>

          <div class="odd-combo-row title-row">
            <div class="combo-box-title">
              <div class="odd-title" *ngFor="let odd of combo1SelectedOdd.OddTitles">
                {{ odd }}
              </div>
            </div>
            <div class="combo-box-title">
              <div class="odd-title" *ngFor="let odd of combo2SelectedOdd.OddTitles">
                {{ odd }}
              </div>
            </div>
            <div class="combo-box-title">
              <div class="odd-title" *ngFor="let odd of combo3SelectedOdd.OddTitles">
                {{ odd }}
              </div>
              <image-loader-utils
                *ngIf="this._DataHelper.LeagueData != undefined && this._DataHelper.LeagueData.length > 0"
                url="star"
                [extraClasses]="'star-icon ' + (tournamentFavourited ? 'favorited' : '')"></image-loader-utils>
            </div>
          </div>
        </div>

        <div class="sports-breadcrumb">
          <div class="left" [routerLink]="['/allsports']">
            <image-loader-utils url="up-arrow" extraClasses="arrow-icon left"></image-loader-utils>
          </div>
          <div class="mid">
            <ng-container *ngIf="sportName !== ''">
              <span (click)="goBack()">
                {{ sportName }}
              </span>
              <ng-container *ngIf="countryName !== ''">
                <image-loader-utils url="up-arrow" extraClasses="arrow-icon right"></image-loader-utils>

                <span (click)="goBack()">
                  <!-- [routerLink]="['/allsports/'+ sportId]" -->
                  {{ countryName }}
                </span>
              </ng-container>

              <ng-container *ngIf="leagueName !== ''">
                <image-loader-utils url="up-arrow" extraClasses="arrow-icon right"></image-loader-utils>

                <span [routerLink]="['/allsports/' + sportId]">
                  {{ leagueName }}
                </span></ng-container
              >
            </ng-container>
            <ng-container *ngIf="sportName === ''">
              <div [routerLink]="['/allsports/']" class="sport-row">Sports</div>
              <!-- <span [routerLink]="['/allsports/'+ sportId]">
                Sports
              </span> -->
            </ng-container>
          </div>
          <div class="right" (click)="add2TournamentFavs()">
            <image-loader-utils url="star" extraClasses="star-icon"></image-loader-utils>
          </div>
        </div>

        <ng-container *ngIf="_UiHelper.sportSearchInputActive && isMobileView">
          <div class="header-container" id="searchMenu">
            <div class="header-content">
              <div id="search-mobile">
                <input
                  [formControl]="searchValue"
                  #search
                  type="search"
                  [placeholder]="filled ? ('search_key_placeholder' | translate) : ''"
                  [ngClass]="{ filled: true }"
                  (blur)="filled = search.value ? true : false"
                  (input)="onInputChange($event)" />
              </div>
            </div>
          </div>
        </ng-container>

        <home-live></home-live>
      </div>
    </div>

    <outrights-component *ngIf="this.tournamentSelectionp1001.isTournamentSelection" [setTournament]="this.tournamentSelectionp1001.tournamentBetradarId"></outrights-component>
    <!--{{this.tournamentSelection.tournamentId}}-->
    <div *ngIf="this.tournamentSelectionp1001.data?.length > 0" class="statistics-container">
      <div class="tournament-standings">
        <div class="standings-wrapper">
          <div class="m-standings-selection d-flex mx-auto">
            <div
              (click)="tournamentStatsPage1('total')"
              [ngClass]="{ active: tournamentSelectionp1001.page === 1 && tournamentSelectionp1001.page1InsideSelection === 'total' }"
              class="m-selection">
              {{ 'League_Table' | translate }}
            </div>
            <div
              (click)="tournamentStatsPage1('home')"
              [ngClass]="{ active: tournamentSelectionp1001.page === 1 && tournamentSelectionp1001.page1InsideSelection === 'home' }"
              class="m-selection">
              {{ 'Home' | translate }}
            </div>
            <div
              (click)="tournamentStatsPage1('away')"
              [ngClass]="{ active: tournamentSelectionp1001.page === 1 && tournamentSelectionp1001.page1InsideSelection === 'away' }"
              class="m-selection">
              {{ 'Away' | translate }}
            </div>
            <div class="m-selection" (click)="tournamentSelectionState(2)" [ngClass]="{ active: tournamentSelectionp1001.page === 2 }">Form table</div>
          </div>
          <div class="table-header d-flex align-items-center justify-content-end px-2 px-md-3">
            <h3 class="mr-auto">{{ 'statistics' | translate }}</h3>
            <div class="standings-selection d-flex ml-auto">
              <div class="selection mx-1 {{ tournamentSelectionp1001.page === 1 ? 'active' : '' }}" (click)="tournamentSelectionState(1)">
                {{ 'League_Table' | translate }}
              </div>
              <div class="selection mx-1 {{ tournamentSelectionp1001.page === 2 ? 'active' : '' }}" (click)="tournamentSelectionState(2)">
                {{ 'Form_table' | translate }}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div *ngIf="tournamentSelectionp1001.page === 1" class="table-wrap">
            <div class="table-head d-flex">
              <div class="league-name my-auto"></div>
              <div class="league-legend-row">
                <div class="league-legend-left">{{ tournamentSelectionp1001.data[0]?.TournamentName }}</div>
                <div class="league-legend d-flex">
                  <div class="label mt-auto">{{ 'Pl' | translate }}</div>
                  <div class="label mt-auto">{{ 'Win_Key' | translate }}</div>
                  <div class="label mt-auto">{{ 'Draw_key' | translate }}</div>
                  <div class="label mt-auto">{{ 'Loss_shortcut' | translate }}</div>
                  <div class="label mt-auto d-none d-lg-block">{{ 'PTS' | translate }}</div>
                  <div class="label mt-auto">{{ 'Goals' | translate }}</div>
                  <div class="label position d-none d-xl-block mobile-display-none">
                    <div class="d-flex flex-column">
                      <div class="mx-auto">{{ 'Home' | translate }}</div>
                      <div class="d-flex mt-auto">
                        <div style="flex: 1; text-align: center">{{ 'Win_Key' | translate }}</div>
                        <div style="flex: 1; text-align: center">{{ 'Draw_key' | translate }}</div>
                        <div style="flex: 1; text-align: center">{{ 'Loss_shortcut' | translate }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="label position mt-auto d-none d-xl-block mobile-display-none">
                    <div class="d-flex flex-column">
                      <div class="mx-auto">{{ 'Away' | translate }}</div>
                      <div class="d-flex mt-auto">
                        <div style="flex: 1; text-align: center">{{ 'Win_Key' | translate }}</div>
                        <div style="flex: 1; text-align: center">{{ 'Draw_key' | translate }}</div>
                        <div style="flex: 1; text-align: center">{{ 'Loss_shortcut' | translate }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="table-body d-flex" *ngFor="let tItem of this.tournamentSelectionp1001.data; let i = index">
                <div class="club-name d-flex my-auto">
                  <div class="item name d-none d-lg-block">
                    <div class="d-flex h-100">
                      <div class="my-auto">{{ i + 1 + '. ' + tItem.CompetitorName }}</div>
                    </div>
                  </div>
                </div>
                <ng-container *ngIf="this.tournamentSelection.page1InsideSelection === 'total'">
                  <div class="club-info d-flex my-auto">
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.Played }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.Win }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.Draw }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.Loss }}</div>
                      </div>
                    </div>
                    <div class="item bold d-none d-lg-block">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.Points }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.Tore }}</div>
                      </div>
                    </div>
                    <div class="item bordered d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HWin }}</div>
                      </div>
                    </div>
                    <div class="item d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HDraw }}</div>
                      </div>
                    </div>
                    <div class="item d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HLos }}</div>
                      </div>
                    </div>
                    <div class="item bordered d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.AWin }}</div>
                      </div>
                    </div>
                    <div class="item d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.ADraw }}</div>
                      </div>
                    </div>
                    <div class="item d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.ALos }}</div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="this.tournamentSelection.page1InsideSelection === 'home'">
                  <div class="club-info d-flex my-auto">
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HPlayed }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HWin }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HDraw }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HLos }}</div>
                      </div>
                    </div>
                    <div class="item bold d-none d-lg-block">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.HPoint }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">-</div>
                      </div>
                    </div>
                    <div class="item bordered d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.AWin }}</div>
                      </div>
                    </div>
                    <div class="item d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.ADraw }}</div>
                      </div>
                    </div>
                    <div class="item d-none d-xl-block mobile-display-none">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.ALos }}</div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="this.tournamentSelection.page1InsideSelection === 'away'">
                  <div class="club-info d-flex my-auto">
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.APlayed }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.AWin }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.ADraw }}</div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.ALos }}</div>
                      </div>
                    </div>
                    <div class="item bold d-none d-lg-block">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">{{ tItem.APoint }}</div>
                      </div>
                    </div>

                    <div class="item">
                      <div class="d-flex h-100">
                        <div class="my-auto mx-auto">-</div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="disclaimer">{{ 'Sports_Text_1' | translate }}</div>
          </div>

          <div *ngIf="tournamentSelectionp1001.page === 2" class="table-wrap">
            <div class="table-head formTable d-flex">
              <div class="leauge-form-row">
                <div class="league-form">
                  <div class="league-legend-left">
                    <div class="season-name">
                      {{ tournamentSelectionp1001.data[0]?.TournamentName }}
                    </div>
                    <div class="underline-arrow">letzte 6 Sp.</div>
                  </div>
                </div>
                <div class="league-legend d-flex">
                  <div></div>
                  <div class="label mt-auto">{{ 'Win_Key' | translate }}</div>
                  <div class="label mt-auto">{{ 'Draw_key' | translate }}</div>
                  <div class="label mt-auto">{{ 'Loss_shortcut' | translate }}</div>
                  <div class="label mt-auto">{{ 'Goals' | translate }}</div>
                  <div class="label mt-auto">{{ 'PTS' | translate }}</div>
                </div>
              </div>
            </div>
            <div class="table-body formTableB d-flex" *ngFor="let tItem of this.tournamentSelectionp1001.data; let k = index">
              <div class="club-name d-flex my-auto">
                <div class="item name d-none d-lg-block">
                  <div class="d-flex h-100">
                    <div class="my-auto">{{ k + 1 + '. ' + tItem.CompetitorName }}</div>
                  </div>
                </div>
              </div>
              <div class="club-form d-flex my-auto">
                <div class="item">
                  <div class="d-flex h-100" style="width: 100%">
                    <div class="my-autto mx-auto" style="flex: 1; justify-content: space-around; display: flex">
                      <ng-container *ngFor="let item of getFormTableDataTranslate(tItem.Form)">
                        <div [ngClass]="{ 'statu-dot-lost': item == '0', 'statu-dot-won': item == '3', 'statu-dot-d': item == '1' }"></div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              <div class="club-info d-flex my-auto">
                <div class="item">
                  <div class="d-flex h-100">
                    <div class="my-auto mx-auto">{{ tItem.FormWin }}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="d-flex h-100">
                    <div class="my-auto mx-auto">{{ tItem.FormDraw }}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="d-flex h-100">
                    <div class="my-auto mx-auto">{{ tItem.FormLost }}</div>
                  </div>
                </div>
                <div class="item">
                  <div class="d-flex h-100" style="flex-shrink: 0">
                    <div class="my-auto mx-auto">-</div>
                  </div>
                </div>
                <div class="item bold">
                  <div class="d-flex h-100">
                    <div class="my-auto mx-auto">{{ tItem.FormPoints }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="disclaimer">{{ 'Sports_Text_1' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="no-searching-data-container" *ngIf="!this._UiHelper.hasSearchData">
    <image-loader-utils url="search" extraClasses="no-search-data"></image-loader-utils>
    <ng-container *ngIf="this._UiHelper.searchTerm == '' || this._UiHelper.searchTerm.length <= 2; else noDataTemplate">
      {{ 'min_search_key' | translate }}
    </ng-container>
    <ng-template #noDataTemplate>
      {{ 'no_data' | translate }}
    </ng-template>
  </div>
</div>
